<template>
  <transition name="confirm-fade">
    <div v-if="show" class="confirm-overlay" @keyup.esc="$emit('cancel')">
      <div class="confirm-dialog" role="dialog" aria-modal="true">
        <header class="confirm-header">
          <i class="bi bi-question-circle"></i>
          <h3>{{ title }}</h3>
        </header>
        <main class="confirm-body">
          <p>{{ message }}</p>
        </main>
        <footer class="confirm-actions">
          <button
            type="button"
            class="btn btn-secondary"
            @click="$emit('cancel')"
          >
            {{ button.no }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="$emit('confirm')"
          >
            {{ button.yes }}
          </button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "VueConfirmDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Confirmation",
    },
    message: {
      type: String,
      default: "Êtes-vous sûr de vouloir continuer ?",
    },
    button: {
      type: Object,
      default: () => ({ yes: "Oui", no: "Non" }),
    },
  },
};
</script>

<style scoped>
.confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}

.confirm-dialog {
  width: min(420px, calc(100% - 2.5rem));
  background: #ffffff;
  border-radius: 20px;
  padding: 1.8rem;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.15);
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.confirm-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.confirm-header i {
  font-size: 1.75rem;
  color: #2563eb;
}

.confirm-header h3 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: #0f172a;
}

.confirm-body p {
  margin: 0;
  color: #475569;
  line-height: 1.5;
}

.confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}

.btn {
  padding: 0.65rem 1.4rem;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.btn:hover {
  transform: translateY(-1px);
}

.btn-primary {
  background: linear-gradient(135deg, #2563eb, #4f46e5);
  color: white;
}

.btn-secondary {
  background: rgba(148, 163, 184, 0.2);
  color: #1f2937;
}

.confirm-fade-enter-active,
.confirm-fade-leave-active {
  transition: opacity 0.2s ease;
}

.confirm-fade-enter,
.confirm-fade-leave-to {
  opacity: 0;
}

@media (max-width: 480px) {
  .confirm-dialog {
    padding: 1.5rem;
    gap: 1rem;
  }

  .confirm-actions {
    flex-direction: column-reverse;
  }

  .btn {
    width: 100%;
  }
}
</style>

